import { IfcFlowTerminalType } from "./index.js";
import { IfcOutletTypeEnumDeserializeStep } from "./index.js";
/* This is generated code, don't modify */
import EntityTypesIfc from "./entity_types_ifc.gen.js";
///**
// * http://www.buildingsmart-tech.org/ifc/ifc4/final/html/link/ifcoutlettype.htm */
export class IfcOutletType extends IfcFlowTerminalType {
    get type() {
        return EntityTypesIfc.IFCOUTLETTYPE;
    }
    get PredefinedType() {
        if (this.PredefinedType_ === void 0) {
            this.PredefinedType_ = this.extractLambda(9, IfcOutletTypeEnumDeserializeStep, false);
        }
        return this.PredefinedType_;
    }
    constructor(localID, internalReference, model) {
        super(localID, internalReference, model);
    }
}
IfcOutletType.query = [EntityTypesIfc.IFCOUTLETTYPE];
IfcOutletType.expectedType = EntityTypesIfc.IFCOUTLETTYPE;
